import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Asset } from '@app/_models/_DTOs/asset';
import { BaseDto } from '@app/_models/_DTOs/baseDto';
import { ITuple } from '@app/_models/tuple';
import { BaseEntity } from '@app/_models/baseEntity';
import { catchError, retry } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { BaseViewModel } from '@app/_models/_viewModels/baseViewModel';
import { InventoryCompletion } from '@app/_models/inventoryCompletion';
import { ExcelComparisonResult } from '@app/_models/_response/excelComparisonResult';
import { BaseExcelModel } from '@app/_models/_DTOs/Excel/baseExcelModel';

export class DataService<T extends BaseDto> {

    constructor(public http: HttpClient, public endpoint: string) { }

    get(id: number) {
        return this.http.get<T>(`${environment.apiUrl}/${this.endpoint}/${id}`);
    }

    getAll() {
        return this.http.get<T[]>(`${environment.apiUrl}/${this.endpoint}`);
    }

    // return data with minimal required attributes
    getAllBasic() {
        return this.http.get<T[]>(`${environment.apiUrl}/${this.endpoint}/basicinfo`);
    }

    // getPage(pageIndex: number, pageSize: number) {
    //     let params = new HttpParams()
    //         .append('pageIndex', `${pageIndex}`)
    //         .append('pageSize', `${pageSize}`)
    //     return this.http.get<ITuple<T>>(`${environment.apiUrl}/${this.endpoint}/`, { params });
    // }

    getPage(page: number, pageSize: number, sorts: string = "", filters: string = "") {
        var params = new HttpParams()
            .append('sorts', `${sorts}`)
            .append('filters', `${filters}`)
            .append('page', `${page}`)
            .append('pageSize', `${pageSize}`);
        return this.http.get<ITuple<T>>(`${environment.apiUrl}/${this.endpoint}`, { params });
    }

    exportExcel(page: number, pageSize: number, sorts: string = "", filters: string = "") {
        var params = new HttpParams()
            .append('sorts', `${sorts}`)
            .append('filters', `${filters}`);
        return this.http.get(`${environment.apiUrl}/${this.endpoint}/ExportExcel`, { params, responseType: "blob" });
    }

    post<K extends BaseViewModel>(object: K) {
        return this.http.post(`${environment.apiUrl}/${this.endpoint}/`, object, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    postWithUpload(formData: FormData) {
        return this.http.post(`${environment.apiUrl}/${this.endpoint}/`, formData,
            { reportProgress: true, observe: 'events' });
    }

    put<K extends BaseViewModel>(object: K, id: number) {
        return this.http.put(`${environment.apiUrl}/${this.endpoint}/${id}`, object, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        });
    }

    putWithUpload(formData: FormData, id: number) {
        return this.http.put(`${environment.apiUrl}/${this.endpoint}/${id}`, formData,
            { reportProgress: true, observe: 'events' });
    }

    delete(id: number) {
        var url = `${environment.apiUrl}/${this.endpoint}/${id}`;
        return this.http.delete(url);
    }

    uploadAssetExcel(formData: FormData, endPoint: string) {
    return this.http.post(`${environment.apiUrl}/${this.endpoint}/${endPoint}/`, formData,
        { reportProgress: true, observe: 'events', responseType: "blob" })
        .pipe(
            catchError(error => {
                // Handle the error locally
                return throwError(() => error);  // Re-throw the error if you want it to be handled by the caller
            })
        );
}

    handleError(error) {

        let errorMessage = '';

        if (error.error instanceof ErrorEvent) {

            // client-side error

            errorMessage = `Error: ${error.error.message}`;

        } else {

            // server-side error

            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;

        }

        window.alert(errorMessage);

        return throwError(errorMessage);

    }
}